// Libs
// Components, Layouts, Pages
// Others
import { IconSvgProps } from '~/utils/interface/common';
// Styles, images, icons

const ReportIconTechnician = (props: IconSvgProps) => {
  //#region Destructuring Props
  const { width = 24, height = 24, strokePath = '#3652A8' } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15 15.7167H14.3667C13.7 15.7167 13.0667 15.975 12.6 16.4417L11.175 17.85C10.525 18.4917 9.46668 18.4917 8.81668 17.85L7.39166 16.4417C6.925 15.975 6.28333 15.7167 5.625 15.7167H5C3.61667 15.7167 2.5 14.6084 2.5 13.2417V4.15002C2.5 2.78336 3.61667 1.67505 5 1.67505H15C16.3833 1.67505 17.5 2.78336 17.5 4.15002V13.2417C17.5 14.6001 16.3833 15.7167 15 15.7167Z'
        stroke={strokePath}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10 8.33338C11.0724 8.33338 11.9417 7.46406 11.9417 6.3917C11.9417 5.31935 11.0724 4.45007 10 4.45007C8.92765 4.45007 8.05832 5.31935 8.05832 6.3917C8.05832 7.46406 8.92765 8.33338 10 8.33338Z'
        stroke={strokePath}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.3333 13.05C13.3333 11.55 11.8417 10.3334 9.99999 10.3334C8.15832 10.3334 6.66666 11.55 6.66666 13.05'
        stroke={strokePath}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ReportIconTechnician;
